import { getAction, deleteAction, putAction, postAction, httpAction } from '@/api/manage'
import Vue from 'vue'
import { UI_CACHE_DB_DICT_DATA } from '@/store/mutation-types'

// /doMistServer
export const doMistServerUrl = `${window._CONFIG['doBaseUrl']}/doMistServer`
export const doCenterServerUrl = `${window._CONFIG['doBaseUrl']}/doCenterHistory`

// 个人工作台项目方案
const addOrEditProject = (params) => postAction(`${doMistServerUrl}/project/saveOrUpdateProject`, params)
const selectProject = (params) => getAction(`${doMistServerUrl}/project/selectByLikeNameProject`, params)
const deleteProject = (params) => postAction(`${doMistServerUrl}/project/deleteByIdProject`, params)
const queryByProjectId = (params) => getAction(`${doMistServerUrl}/project/queryById`, params)
const getLibraryByProjectId = (params) => getAction(`${doMistServerUrl}/project/selectByIdProject`, params)
const addOrEditSolution = (params) => postAction(`${doMistServerUrl}/solution/saveOrUpdateSolution`, params)
const selectSolution = (params) => getAction(`${doMistServerUrl}/solution/selectByLikeNameSolutionPage`, params)
const deleteSolution = (params) => postAction(`${doMistServerUrl}/solution/deleteByIdSolution`, params)
const lateOpenSolution = (params) => getAction(`${doMistServerUrl}/solution/selectByLimitRecently`, params)
const selectPartLibrary = (params) => getAction(`${doMistServerUrl}/resource/getResourceByResourceCode`, params)
const getPartNumByLibraryId = (params) => getAction(`${doMistServerUrl}/part/getPartsByLibrary`, params)
const getTreeByLibraryId = (params) => getAction(`${doMistServerUrl}/partLibrary/getResourceTypeByPid`, params)
const getPartLibraryByName = (params) => postAction(`${doMistServerUrl}/resource/getResourceByConditions`, params)
const getResourcesByProId = (params) => getAction(`${doMistServerUrl}/projectResource/getResourceTreeByProjectId`, params)
const addResourceToTree = (params) => postAction(`${doMistServerUrl}/resource/savePartResource`, params)
const editResourceTreeNodeName = (params) => postAction(`${doMistServerUrl}/resource/updatePartResourceById`, params)
const getFileByNodeId = (params) => getAction(`${doMistServerUrl}/resource/getResourcePropsByPid`, params)
const getResourcePropsByPidAndName = (params) => getAction(`${doMistServerUrl}/resource/getResourcePropsByPidAndName`, params)
const delCatelogById = (params) => postAction(`${doMistServerUrl}/resource/deletePartResourceById`, params)
const getVersions = (params) => getAction(`${doMistServerUrl}/config/downClient`, params)
const setUserInfo = (params) => postAction(`${window._CONFIG['domianURL']}/sys/user/editMyInfo`, params)
const getResourceConvertState = (params) => getAction(`${doMistServerUrl}/projectResource/getProjectResourceConvertStatus`, params)
const getSolRecommendState = (params) => getAction(`${doMistServerUrl}/solution/selectBySolutionJobMessage`, params)
const getResourceByStandardId = (params) => getAction(`${doMistServerUrl}/resource/getResourceByStandardId`, params)
const findResourceByConditions = (params) => postAction(`${doMistServerUrl}/resource/findResourceByConditions`, params)
const findResourceByConditionsPlus = (params) => postAction(`${doMistServerUrl}/resource/findResourceByConditionsPlus`, params)
const getUserByRelTenantId = (params) => getAction(`${window._CONFIG['domianURL']}/do/api/getUserByRelTenantId`, params)
const selectByUserIdProjectPermission = (params) => getAction(`${doMistServerUrl}/projectPermission/selectByUserIdProjectPermission`, params)
const insertOrUpdateProjectPermission = (params) => postAction(`${doMistServerUrl}/projectPermission/insertOrUpdateProjectPermission`, params)
const saveRoleApps = (params) => postAction('/sysApp/saveRoleApps', params)
const getRoleApps = (params) => getAction('/sysApp/getRoleApps', params)
const saveTenantApps = (params) => postAction('/sys/tenant/saveTenantApps', params)
const getTenantApps = (params) => getAction('/sys/tenant/getTenantApps', params)

const getAppsList = (params) => getAction(`${window._CONFIG['domianURL']}/sysApp/list`, params)
const getUserById = (params) => getAction(`${window._CONFIG['domianURL']}/sys/user/queryByIds`, params)

const selectByUserIdPermission = (params) => getAction(`${doMistServerUrl}/solutionPermission/selectByUserIdPermission`, params)
const insertOrUpdateSolutionPermission = (params) => postAction(`${doMistServerUrl}/solutionPermission/insertOrUpdateSolutionPermission`, params)

// 数据看板
const getUserByRolTenantId = (params) => getAction(`${doMistServerUrl}/kanban/user/getUserByRelTenantId`, params)
const getUserStatistics = (params) => getAction(`${doMistServerUrl}/kanban/history/data/getUserStatistics`, params)
const getUserStatisticsDetail = (params) => getAction(`${doMistServerUrl}/kanban/user/getUserStatisticsDetail`, params)
const getSolutionStatistics = (params) => getAction(`${doMistServerUrl}/kanban/solution/getSolutionStatistics`, params)
const getRpsDownloadNumber = (params) => getAction(`${doMistServerUrl}/kanban/history/data/getRpsDownloadNumber`, params)
const getSolutionDownloadNumber = (params) => getAction(`${doMistServerUrl}/kanban/history/data/getSolutionDownloadNumber`, params)
const getHisRpsDownload = (params) => getAction(`${doMistServerUrl}/kanban/solutionDownload/getHisRpsDownload`, params)
const getUserLoginStatistics = (params) => getAction(`${doMistServerUrl}/kanban/history/data/getUserLoginStatistics`, params)
const getUserLoginStatisticsDetail = (params) => getAction(`${doMistServerUrl}/kanban/userLogin/getUserLoginStatisticsByDate`, params)
const exportKanBan = (params) => getAction(`${doMistServerUrl}/kanban/oss/exportKanBan`, params)
const getTenantList = (params) => getAction(`${window._CONFIG['domianURL']}/sys/tenant/list`, params)
const saveUserActiveTime = (params) => postAction(`${doMistServerUrl}/kanban/userLogin/saveUserActiveTime`, params)

// 历史夹具
const getHistoryClampList = (params) => getAction(`${doCenterServerUrl}/clamp/selectByAreaIdOrStandardId`, params)
const restConvertClampNpy = (params) => postAction(`${doCenterServerUrl}/clamp/restConvertClamp`, params)
const deleteClamp = (params) => postAction(`${doCenterServerUrl}/clamp/clamps-delete`, params)
const editClampInfo = (params) => postAction(`${doCenterServerUrl}/clamp/clamps`, params)
// 往历史单元中补充焊枪
const addGunByHistoryClamp = (params) => postAction(`${doCenterServerUrl}/clamp/addGunByHistoryClamp`, params)

// 零件
const editPart = (params) => postAction(`${doCenterServerUrl}/part/parts`, params)
const delPart = (params) => postAction(`${doCenterServerUrl}/part/parts-delete`, params)

// 角色管理
const addRole = (params, tenantId = undefined) => postAction('/sys/role/add', params, tenantId)
const editRole = (params, tenantId = undefined) => putAction('/sys/role/edit', params, tenantId)
const checkRoleCode = (params) => getAction('/sys/role/checkRoleCode', params)
const queryall = (params) => getAction('/sys/role/queryall', params)

// 用户管理
const addUser = (params) => postAction('/sys/user/add', params)
const editUser = (params) => putAction('/sys/user/edit', params)
const queryUserRole = (params) => getAction('/sys/user/queryUserRole', params)
const getUserList = (params) => getAction('/sys/user/list', params)
const frozenBatch = (params) => putAction('/sys/user/frozenBatch', params)
// 验证用户是否存在
const checkOnlyUser = (params) => getAction('/sys/user/checkOnlyUser', params)
// 改变密码
const changePassword = (params) => putAction('/sys/user/changePassword', params)

// 权限管理
const addPermission = (params) => postAction('/sys/permission/add', params)
const editPermission = (params) => putAction('/sys/permission/edit', params)
const getPermissionList = (params) => getAction('/sys/permission/list', params)
const getSystemMenuList = (params) => getAction('/sys/permission/getSystemMenuList', params)
const getSystemSubmenu = (params) => getAction('/sys/permission/getSystemSubmenu', params)
const getSystemSubmenuBatch = (params) => getAction('/sys/permission/getSystemSubmenuBatch', params)
const queryTreeList = (params) => getAction('/sys/permission/queryTreeList', params)
const queryTreeListForRole = (params) => getAction('/sys/role/queryTreeList', params)
const queryListAsync = (params) => getAction('/sys/permission/queryListAsync', params)
const queryRolePermission = (params) => getAction('/sys/permission/queryRolePermission', params)
const saveRolePermission = (params) => postAction('/sys/permission/saveRolePermission', params)
const queryPermissionsByUser = (params) => getAction('/sys/permission/getUserPermissionByToken', params)
const loadAllRoleIds = (params) => getAction('/sys/permission/loadAllRoleIds', params)
const getPermissionRuleList = (params) => getAction('/sys/permission/getPermRuleListByPermId', params)
const queryPermissionRule = (params) => getAction('/sys/permission/queryPermissionRule', params)

// 部门管理
const queryDepartTreeList = (params) => getAction('/sys/sysDepart/queryTreeList', params)
const queryDepartTreeSync = (params) => getAction('/sys/sysDepart/queryDepartTreeSync', params)
const queryIdTree = (params) => getAction('/sys/sysDepart/queryIdTree', params)
const queryParentName = (params) => getAction('/sys/sysDepart/queryParentName', params)
const searchByKeywords = (params) => getAction('/sys/sysDepart/searchBy', params)
const deleteByDepartId = (params) => deleteAction('/sys/sysDepart/delete', params)

// 二级部门管理
const queryDepartPermission = (params) => getAction('/sys/permission/queryDepartPermission', params)
const saveDepartPermission = (params) => postAction('/sys/permission/saveDepartPermission', params)
const queryTreeListForDeptRole = (params) => getAction('/sys/sysDepartPermission/queryTreeListForDeptRole', params)
const queryDeptRolePermission = (params) => getAction('/sys/sysDepartPermission/queryDeptRolePermission', params)
const saveDeptRolePermission = (params) => postAction('/sys/sysDepartPermission/saveDeptRolePermission', params)
const queryMyDepartTreeList = (params) => getAction('/sys/sysDepart/queryMyDeptTreeList', params)
const queryMyDepartTreeList2 = (params) => getAction('/sys/sysDepart/queryMyDeptTreeList2', params)

// 日志管理
const deleteLog = (params) => deleteAction('/sys/log/delete', params)
const deleteLogList = (params) => deleteAction('/sys/log/deleteBatch', params)

// 数据字典
const addDict = (params) => postAction('/sys/dict/add', params)
const editDict = (params) => putAction('/sys/dict/edit', params)
const treeList = (params) => getAction('/sys/dict/treeList', params)
const addDictItem = (params) => postAction('/sys/dictItem/add', params)
const editDictItem = (params) => putAction('/sys/dictItem/edit', params)

// 字典标签专用（通过code获取字典数组）
export const ajaxGetDictItems = (code, params) => getAction(`/sys/dict/getDictItems/${code}`, params)
// 从缓存中获取字典配置
function getDictItemsFromCache(dictCode) {
  if (Vue.ls.get(UI_CACHE_DB_DICT_DATA) && Vue.ls.get(UI_CACHE_DB_DICT_DATA)[dictCode]) {
    let dictItems = Vue.ls.get(UI_CACHE_DB_DICT_DATA)[dictCode]
    // console.log("-----------getDictItemsFromCache----------dictCode="+dictCode+"---- dictItems=",dictItems)
    return dictItems
  }
}

// 系统通告
const doReleaseData = (params) => getAction('/sys/annountCement/doReleaseData', params)
const doReovkeData = (params) => getAction('/sys/annountCement/doReovkeData', params)
// 获取系统访问量
const getLoginfo = (params) => getAction('/sys/loginfo', params)
const getVisitInfo = (params) => getAction('/sys/visitInfo', params)

// 根据部门主键查询用户信息
const queryUserByDepId = (params) => getAction('/sys/user/queryUserByDepId', params)

// 重复校验
const duplicateCheck = (params) => getAction('/sys/duplicate/check', params)
// 加载分类字典
const loadCategoryData = (params) => getAction('/sys/category/loadAllData', params)
const checkRuleByCode = (params) => getAction('/sys/checkRule/checkByCode', params)
// 加载我的通告信息
const getUserNoticeInfo = (params) => getAction('/sys/sysAnnouncementSend/getMyAnnouncementSend', params)
const getTransitURL = url => `/sys/common/transitRESTful?url=${encodeURIComponent(url)}`

// 保持登录状态
const getKeepAlive = (params) => getAction('/sys/keepAlive', params)
// 中转HTTP请求
export const transitRESTful = {
  get: (url, parameter) => getAction(getTransitURL(url), parameter),
  post: (url, parameter) => postAction(getTransitURL(url), parameter),
  put: (url, parameter) => putAction(getTransitURL(url), parameter),
  http: (url, parameter) => httpAction(getTransitURL(url), parameter)
}

// 资源
// 根据父节点查询子节点
const getResourcePropsByPid = (params) => getAction(`${doMistServerUrl}/resource/getResourcePropsByPid`, params)

// 图框模板库
// 新建项目库文件夹
const savePartResource = (params) => postAction('/doMistServer/resource/savePartResource', params)
// 根据条件查询
const getResourceByCondition = (params) => postAction('/doMistServer/resource/findResourceByConditions', params)

const getResourceByPId = (params) => getAction('/doMistServer/resource/getResourcePropsByPid', params)

const getResourceByIds = (params) => getAction('/doMistServer/part/getPartsByResourceIds', params)

const delResourceByIds = (params) => postAction('/doMistServer/resource/deletePartResourceByIds', params)

export {
  // 看板
  getUserByRolTenantId,
  getUserStatistics,
  getUserStatisticsDetail,
  getSolutionStatistics,
  getRpsDownloadNumber,
  getSolutionDownloadNumber,
  getHisRpsDownload,
  getUserLoginStatistics,
  getUserLoginStatisticsDetail,
  exportKanBan,
  getTenantList,
  saveUserActiveTime,
  insertOrUpdateProjectPermission,
  // end
  insertOrUpdateSolutionPermission,
  selectByUserIdPermission,
  selectByUserIdProjectPermission,
  getResourceByStandardId,
  findResourceByConditions,
  findResourceByConditionsPlus,
  addOrEditProject,
  selectProject,
  deleteProject,
  queryByProjectId,
  getLibraryByProjectId,
  addOrEditSolution,
  selectSolution,
  deleteSolution,
  lateOpenSolution,
  selectPartLibrary,
  getPartNumByLibraryId,
  getTreeByLibraryId,
  getPartLibraryByName,
  getResourcesByProId,
  addResourceToTree,
  editResourceTreeNodeName,
  getFileByNodeId,
  getResourcePropsByPidAndName,
  delCatelogById,
  getVersions,
  setUserInfo,
  getResourceConvertState,
  getSolRecommendState,
  getHistoryClampList,
  restConvertClampNpy,
  deleteClamp,
  editClampInfo,
  editPart,
  delPart,
  getUserById,
  // imgView,
  // doMian,
  getUserByRelTenantId,
  addRole,
  editRole,
  checkRoleCode,
  addUser,
  editUser,
  queryUserRole,
  getUserList,
  queryall,
  frozenBatch,
  checkOnlyUser,
  changePassword,
  getPermissionList,
  addPermission,
  editPermission,
  queryTreeList,
  queryListAsync,
  queryRolePermission,
  saveRolePermission,
  queryPermissionsByUser,
  loadAllRoleIds,
  getPermissionRuleList,
  queryPermissionRule,
  queryDepartTreeList,
  queryDepartTreeSync,
  queryIdTree,
  queryParentName,
  searchByKeywords,
  deleteByDepartId,
  deleteLog,
  deleteLogList,
  addDict,
  editDict,
  treeList,
  addDictItem,
  editDictItem,
  doReleaseData,
  doReovkeData,
  getLoginfo,
  getVisitInfo,
  queryUserByDepId,
  duplicateCheck,
  queryTreeListForRole,
  getSystemMenuList,
  getSystemSubmenu,
  getSystemSubmenuBatch,
  loadCategoryData,
  checkRuleByCode,
  queryDepartPermission,
  saveDepartPermission,
  queryTreeListForDeptRole,
  queryDeptRolePermission,
  saveDeptRolePermission,
  queryMyDepartTreeList,
  queryMyDepartTreeList2,
  getUserNoticeInfo,
  getDictItemsFromCache,
  getKeepAlive,
  getResourcePropsByPid,
  saveRoleApps,
  getRoleApps,
  getAppsList,
  saveTenantApps,
  getTenantApps,
  getResourceByCondition,
  getResourceByPId,
  getResourceByIds,
  delResourceByIds,
  addGunByHistoryClamp,
  savePartResource
}
